module.exports = __webpack_public_path__ + "static/img/c2.6b1c4f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/c2.png
// module id = wgwt
// module chunks = 0